import { render } from "./DropdownGeneric.vue?vue&type=template&id=2a92ff14"
import script from "./DropdownGeneric.vue?vue&type=script&lang=ts"
export * from "./DropdownGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script